// import {
//   MagnifyingGlassIcon,
//   ChevronDownIcon,
// } from "@heroicons/react/24/outline";
// import React, { useEffect, useState, useRef } from "react";
// import { format, subDays, subWeeks, subMonths } from "date-fns";

// export const NotificationFilter = ({
//   setSelectedType,
//   setSearch,
//   setDateStart = () => {},
//   setDateEnd = () => {},
// }) => {
//   const [searchText, setSearchText] = useState("");
//   const [activeTab, setActiveTab] = useState("System");
//   const [activeRange, setActiveRange] = useState("Today");
//   const [isDateFilterOpen, setIsDateFilterOpen] = useState(false);
//   const dateFilterRef = useRef(null);

//   const dateRangeOptions = [
//     { label: "Today" },
//     { label: "3 days ago" },
//     { label: "1 week ago" },
//     { label: "1 month ago" },
//   ];

//   const handleSearch = (e) => {
//     if (e.key === "Enter") setSearch(searchText);
//   };

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         dateFilterRef.current &&
//         !dateFilterRef.current.contains(event.target)
//       ) {
//         setIsDateFilterOpen(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleTabChange = (tabName) => {
//     setActiveTab(tabName);
//     setSelectedType(tabName);
//   };

//   const handleDateRangeChange = (rangeLabel) => {
//     setActiveRange(rangeLabel);
//     setIsDateFilterOpen(false);

//     const today = new Date();
//     let startDate = today;
//     let endDate = today;

//     switch (rangeLabel) {
//       case "Today":
//         break;
//       case "3 days ago":
//         startDate = subDays(today, 2); // 3 hari termasuk hari ini
//         break;
//       case "1 week ago":
//         startDate = subWeeks(today, 1);
//         break;
//       case "1 month ago":
//         startDate = subMonths(today, 1);
//         break;
//     }

//     setDateStart(format(startDate, "yyyy-MM-dd"));
//     setDateEnd(format(endDate, "yyyy-MM-dd"));
//   };

//   useEffect(() => {
//     handleTabChange("System");
//     handleDateRangeChange("Today");
//   }, []);

//   return (
//     <div className="flex flex-col md:flex-row items-center justify-between w-full gap-4 bg-white px-4 pt-4 pb-5 rounded-t-lg">
//       {/* Grup Filter Kiri */}
//       <div className="flex items-center gap-3">
//         {/* Tombol Tab System & Announcement */}
//         <div
//           onClick={() => handleTabChange("System")}
//           className={`px-5 py-2 text-sm font-medium border rounded-full transition-colors cursor-pointer ${
//             activeTab === "System"
//               ? "bg-cyan-50 border-[#007A78] text-[#212121]"
//               : "bg-white border-[#DDE1E6] text-[#212121] hover:bg-gray-50"
//           }`}
//         >
//           System
//         </div>
//         <div
//           onClick={() => handleTabChange("Announcement")}
//           className={`px-5 py-2 text-sm font-medium border rounded-full transition-colors cursor-pointer ${
//             activeTab === "Announcement"
//               ? "bg-cyan-50 border-[#007A78] text-[#212121]"
//               : "bg-white border-[#DDE1E6] text-[#212121] hover:bg-gray-50"
//           }`}
//         >
//           Announcement
//         </div>

//         <div className="h-6 w-px bg-black"></div>

//         {/* --- PERUBAHAN FILTER TANGGAL DIMULAI DI SINI --- */}
//         <div className="flex items-center gap-3">
//           <span className="text-sm text-gray-600">Range by</span>
//           <div className="relative" ref={dateFilterRef}>
//             <button
//               onClick={() => setIsDateFilterOpen(!isDateFilterOpen)}
//               className="flex items-center gap-2 px-4 py-2 text-sm bg-white ring-1 ring-[#007A78] rounded-md"
//             >
//               <span className="font-medium text-gray-800">{activeRange}</span>
//               <ChevronDownIcon
//                 className={`w-4 h-4 text-gray-500 transition-transform ${
//                   isDateFilterOpen ? "rotate-180" : ""
//                 }`}
//               />
//             </button>
//             {isDateFilterOpen && (
//               <div className="absolute top-full mt-2 w-36 bg-white border border-gray-200 rounded-md shadow-lg z-10 p-2">
//                 {dateRangeOptions.map((option, index) => (
//                   <div
//                     key={option.label}
//                     onClick={() => handleDateRangeChange(option.label)}
//                     className={`w-full text-left px-3 py-1.5 text-sm rounded-md ring-1 cursor-pointer ${
//                       activeRange === option.label
//                         ? "bg-gray-100 font-semibold ring-[#007A78]"
//                         : "hover:bg-gray-100 ring-[#DDE1E6]"
//                     } ${index !== dateRangeOptions.length - 1 ? "mb-4" : ""}`}
//                   >
//                     {option.label}
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>
//         {/* --- PERUBAHAN FILTER TANGGAL SELESAI DI SINI --- */}
//       </div>

//       {/* --- PERUBAHAN GRUP FILTER KANAN (SEARCH) DIMULAI DI SINI --- */}
//       <div className="relative flex items-center w-full max-w-xs">
//         <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//           <MagnifyingGlassIcon className="w-5 h-5 text-gray-400" />
//         </div>
//         <input
//           type="text"
//           placeholder="Search Assets"
//           className="w-full pl-10 pr-3 py-2 text-sm bg-gray-100 border-transparent rounded-md focus:outline-none focus:ring-2 focus:ring-cyan-500"
//           value={searchText}
//           onChange={(e) => setSearchText(e.target.value)}
//           onKeyDown={handleSearch}
//         />
//       </div>
//       {/* --- PERUBAHAN GRUP FILTER KANAN (SEARCH) SELESAI DI SINI --- */}
//     </div>
//   );
// };

// export default NotificationFilter;

import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import React, { useEffect, useState, forwardRef } from "react";
import { useQuery } from "@tanstack/react-query"; // 1. Import useQuery
import Dropdown from "../commons/Dropdown";
import { baseAxios } from "../../apis";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";

// --- Custom Date Input (Unchanged) ---
const CustomDateInput = forwardRef(({ value, onClick }, ref) => (
  <div
    onClick={onClick}
    ref={ref}
    className="bg-white rounded-xl px-4 py-4 shadow-sm flex items-center justify-between cursor-pointer"
  >
    <div>
      <div className="text-xs text-gray-500">Date Range</div>
      <div className="font-bold text-gray-900">{value || "All Time"}</div>
    </div>
    <img
      src="https://cdn.builder.io/api/v1/image/assets/TEMP/605c2d0aeffedaa7d06c1c9293abf5d193124a0e330a221e758d4cacb2b406a9?placeholderIfAbsent=true&apiKey=59c0fa6b8aa4495494df54f00a70cb5c"
      alt="calendar icon"
      className="w-4 h-4 ml-2"
    />
  </div>
));

// 2. Create a custom hook for the "Type" (Bots) dropdown data
const useBotTypesQuery = () => {
  return useQuery({
    queryKey: ["botTypesForFilter"],
    queryFn: () => baseAxios.get("/api/strategy-lists").then((res) => res.data),
    // Transform the data right here to fit the dropdown's needs
    select: (data) => {
      const botList = data?.bot_master_list || [];

      return [{ id: "", bot_name: "All Type" }, ...data.bot_master_list].map(
        (bt) => ({ id: bt.id, name: bt.bot_name })
      );
    },
  });
};

// 3. Create a custom hook for the "Exchange" dropdown data
const useExchangesForFilterQuery = () => {
  return useQuery({
    queryKey: ["exchangesForFilter"],
    queryFn: () => baseAxios.get(`/api/get_exchanges`).then((res) => res.data),
    select: (data) => {
      const allExchanges = data?.all_exchanges || [];
      return [{ id: "", exchange: "All Exchange" }, ...allExchanges].map(
        (ex) => ({
          id: ex?.id,
          name: ex?.exchange.charAt(0).toUpperCase() + ex?.exchange.slice(1),
        })
      );
    },
  });
};

export const NotificationFilter = ({
  selectedExchange,
  setSelectedExchange,
  selectedType,
  setSelectedType,
  setSearch,
  setDateStart = () => {},
  setDateEnd = () => {},
}) => {
  // 4. REMOVE the old state for dropdown options
  // const [bots, setBots] = useState([]);
  // const [exchanges, setExchanges] = useState([]);

  // UI-specific state remains
  const [searchText, setSearchText] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  // 5. REMOVE the useEffects that fetched data for the dropdowns

  // 6. Call the new hooks to get the dropdown options
  const { data: bots = [] } = useBotTypesQuery();
  const { data: exchanges = [] } = useExchangesForFilterQuery();

  const handleSearch = (e) => {
    if (e.key === "Enter") setSearch(searchText);
  };

  // This useEffect for handling the date range is UI logic and remains unchanged
  useEffect(() => {
    if (startDate && endDate) {
      setDateStart(format(startDate, "yyyy-MM-dd"));
      setDateEnd(format(endDate, "yyyy-MM-dd"));
    } else {
      setDateStart(null);
      setDateEnd(null);
    }
  }, [startDate, endDate, setDateStart, setDateEnd]);

  // The JSX remains exactly the same
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 items-start justify-start">
      <Dropdown
        id="exchange"
        placeholder="All Exchange"
        value={selectedExchange}
        onChange={(val) => setSelectedExchange(val)}
        style="group"
        options={exchanges}
        className={"shadow-sm !border-none"}
      />
      <Dropdown
        id="type"
        placeholder="All Type"
        label="Type"
        value={selectedType}
        onChange={(val) =>
          setSelectedType(val.name === "All Type" ? null : val)
        }
        style="group"
        options={bots}
        className={"shadow-sm !border-none"}
      />

      <DatePicker
        selectsRange={true}
        startDate={startDate}
        endDate={endDate}
        onChange={(update) => {
          setDateRange(update);
        }}
        isClearable={true}
        dateFormat="MMM d, yyyy"
        customInput={<CustomDateInput />}
      />

      <div className="bg-white rounded-xl px-4 py-4 shadow-sm flex items-center">
        <div className="bg-[#697077]/10 flex items-center gap-2 w-full  px-4 rounded-xl">
          <MagnifyingGlassIcon className="w-[24px] h-[24px]" />
          <input
            type="text"
            placeholder="Search"
            className="bg-transparent text-sm text-gray-800 placeholder-gray-400 focus:outline-none w-full border-none"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={handleSearch}
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationFilter;
